import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'トップ', path: '/' },
    { name: 'サービス内容', path: '/services' },
    { name: '施工事例', path: '/case-studies' },
    { name: '会社概要', path: '/about' },
    { name: '求人情報', path: '/careers' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 cursor-pointer">
            <h1 className={`text-xl sm:text-2xl font-bold transition-colors duration-300 ${
              isScrolled ? 'text-[#1e3a5f]' : 'text-white'
            }`}>
              おかやま屋根工事株式会社
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-medium transition-all duration-200 hover:opacity-80 cursor-pointer ${
                  isScrolled ? 'text-gray-700' : 'text-white'
                } ${location.pathname === link.path ? 'border-b-2 border-current' : ''}`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="tel:0860123456"
              className="inline-flex items-center px-5 py-2.5 text-sm font-bold text-white bg-[#ff6b35] rounded-lg hover:bg-[#e55a28] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill mr-2"></i>
              086-012-3456
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center px-5 py-2.5 text-sm font-bold text-white bg-[#1e3a5f] rounded-lg hover:bg-[#152a45] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg transition-colors duration-200 cursor-pointer"
          >
            <i className={`text-2xl ${isScrolled ? 'text-[#1e3a5f]' : 'text-white'} ${
              isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
            }`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-xl">
          <nav className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-4 py-3 text-base font-medium text-gray-700 hover:bg-gray-50 rounded-lg transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.path ? 'bg-gray-100' : ''
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-4 space-y-3">
              <a
                href="tel:0860123456"
                className="flex items-center justify-center px-5 py-3 text-base font-bold text-white bg-[#ff6b35] rounded-lg hover:bg-[#e55a28] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill mr-2"></i>
                086-012-3456
              </a>
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center justify-center px-5 py-3 text-base font-bold text-white bg-[#1e3a5f] rounded-lg hover:bg-[#152a45] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                お問い合わせ
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
